import React from "react";
import "./Guidelines.css"
import { Rep } from "../../classes/Workout";
import { withTranslation, WithTranslation } from "react-i18next";
import Hands from '../../components/Hands/Hands';
import { HangboardDisplay } from "../../assets/hangboards/hangboardDisplay";
import { Grid } from "semantic-ui-react";

interface guidelinesProps extends WithTranslation{
    rep: Rep
    nextRep: any
    hangboard:string
    className?:string
}
class Guidelines extends React.Component<guidelinesProps>{
    // No constructor needed - no state to initialize
    hangboardDisplay =(holds)=>{
        if(this.props.hangboard!=='none' && holds)
            return(
                <HangboardDisplay unclickable name={this.props.hangboard} usedHolds={holds}/>
            )
        return null;
    }
    render(){
        // Add null checks to prevent undefined property access
        if (!this.props.rep) {
            return <div>Loading...</div>;
        }
       
        const guidelineValue = this.props.rep.intensity>0 ?
        (<div className={this.props.className}>
            <Grid width="100%" height="100%">
                <Grid.Row className="hangboardRow" width="100%">
                    <div className ='hangboardDisplay'>
                        {this.hangboardDisplay(this.props.rep.holds)}
                    </div>
                </Grid.Row>
                <Grid.Row width="100%"><Hands fingers={this.props.rep.fingers} fingerClicked={() => {}}/></Grid.Row>
            </Grid>
        </div>)
        :(<>
            <div className="nextUp">
                <h3>Up Next</h3>
            </div>
            <div className={this.props.className} style={{opacity: "0.6"}}>
                <Grid verticalAlign='middle' >
                    <Grid.Row className="hangboardRow">
                        <div className ='hangboardDisplay'>
                            {this.props.nextRep ? this.hangboardDisplay(this.props.nextRep.holds) : null}
                        </div>
                    </Grid.Row>
                    <Grid.Row>{this.props.nextRep ? <Hands fingers={this.props.nextRep.fingers} fingerClicked={() => {}}/> : null}</Grid.Row>
                </Grid>
            </div>
        </>)
        return guidelineValue;
    }
}

export default withTranslation('workout')(Guidelines);